import { createSlice } from '@reduxjs/toolkit';
import { AsyncState } from '../types';
import { TaskTypeApi, TaskTypeDto } from '../../http';
import { FindAllResponse } from '../../http/types';
import { createFetchAsync } from '../slice.utils';

const taskTypeApi = new TaskTypeApi();

export const fetchTaskTypeAsync = createFetchAsync(
  'taskType',
  'findAll',
  async (params, { rejectWithValue }) => {
    try {
      return await taskTypeApi.findAll({ limit: 1000, ...params });
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const forceFetchTaskType = fetchTaskTypeAsync.asyncThunk;

export const fetchTaskType = (payload) => (dispatch, getState) => {
  const {
    taskType: { findAll }
  } = getState();

  if (!findAll.payload && findAll.loading == false) {
    dispatch(forceFetchTaskType(payload));
  }
};

type TaskTypeState = {
  findAll: AsyncState<FindAllResponse<TaskTypeDto>>;
};

const initialState: TaskTypeState = {
  findAll: fetchTaskTypeAsync.initialState
};

const taskType = createSlice({
  name: 'taskType',
  initialState,
  reducers: {},
  extraReducers: {
    ...fetchTaskTypeAsync.extraReducers
  }
});

export default taskType.reducer;
